import { State } from "../../../redux/state";

export const settingSelector = (state: State) =>
  state.instagramLogin.settings;

export const loginUrlSelector = (state: State) =>
  state.instagramLogin.loginUrl;

export const errorSelector = (state: State) => state.instagramLogin.error;
